import React from "react";
import Box from "@mui/material/Box";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import { useThemeMode } from "../theme/ThemeContext";

const ThemeSelector = () => {
  const { themeMode, setThemeMode } = useThemeMode();

  const handleChange = (_, newMode) => {
    if (newMode !== null) {
      setThemeMode(newMode);
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 24,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 10,
      }}>
      <ToggleButtonGroup
        value={themeMode}
        exclusive
        onChange={handleChange}
        size="small"
        sx={(theme) => ({
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          backgroundColor:
            theme.palette.mode === "light"
              ? "rgba(255, 255, 255, 0.7)"
              : "rgba(18, 18, 18, 0.7)",
          borderRadius: "24px",
          border: `1px solid ${theme.palette.divider}`,
          "& .MuiToggleButtonGroup-grouped": {
            border: "none",
            borderRadius: "20px !important",
            mx: 0.25,
            my: 0.25,
            px: 1.25,
            py: 0.75,
            "&.Mui-selected": {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
            },
          },
        })}>
        <ToggleButton value="light" aria-label="light mode">
          <LightModeIcon fontSize="small" />
        </ToggleButton>
        <ToggleButton value="dark" aria-label="dark mode">
          <DarkModeIcon fontSize="small" />
        </ToggleButton>
        <ToggleButton value="system" aria-label="system mode">
          <SettingsBrightnessIcon fontSize="small" />
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default ThemeSelector;
